import React, { memo, useEffect, useState } from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { QuestionnaireTableQuestion, QuestionnaireTableAnswer } from "../QuestionnaireTableField";
import { setAnswer } from "../../../../../appRedux/actions/FormsV2";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { createAnswer } from "../questionnarieTableScripts";
import { createOptions } from "../questionnarieTableScripts";

interface PutInOrderFieldProps {
   question: QuestionnaireTableQuestion;
   formUuid: number;
}

const PutInOrderField: React.FC<PutInOrderFieldProps> = ({ question, formUuid }) => {
   const itemsInOrder = useSelector((state: RootStateOrAny) =>
      state.formsv2.formInfo[formUuid]?.questionnaireTableAnswers?.[question.questionId]
         ? createOptions(
              state.formsv2.formInfo[formUuid].questionnaireTableAnswers[question.questionId]
                 ?.answer
           )
         : []
   );
   const dispatch = useDispatch();

   useEffect(() => {
      if (itemsInOrder.length === 0) {
         const answer = question.options?.map((item) => `"${item}"`).toString();
         dispatch(setAnswer(createAnswer(question, { answer }), formUuid));
      }
   }, []);

   const onDragEnd = (result) => {
      if (!result.destination) {
         return;
      }

      const reorderedItems = [...itemsInOrder];
      const [movedItem] = reorderedItems.splice(result.source.index, 1);
      reorderedItems.splice(result.destination.index, 0, movedItem);

      const answer = reorderedItems.map((item) => `"${item}"`).toString();
      dispatch(setAnswer(createAnswer(question, { answer }), formUuid));
   };

   return (
      <div className="questionnaire-field__container">
         <p className="p1 questionnaire-field__title">{question.content}</p>
         <DragDropContext onDragEnd={onDragEnd}>
            <Droppable
               droppableId={question.questionId.toString()}
               mode="virtual"
               renderClone={(provided, snapshot, rubric) => (
                  <div
                     className="put-in-order-field__item"
                     ref={provided.innerRef}
                     {...provided.draggableProps}
                     {...provided.dragHandleProps}
                     style={{
                        ...provided.draggableProps.style
                     }}
                  >
                     {rubric.source.index + 1 + "."}&emsp;{itemsInOrder[rubric.source.index]}
                  </div>
               )}
            >
               {(provided, snapshot) => (
                  <div
                     className="put-in-order-field__container"
                     {...provided.droppableProps}
                     ref={provided.innerRef}
                  >
                     {itemsInOrder.map((item, index) => (
                        <Draggable key={index} draggableId={index.toString()} index={index}>
                           {(provided, snapshot) => (
                              <div
                                 className="put-in-order-field__item"
                                 ref={provided.innerRef}
                                 {...provided.draggableProps}
                                 {...provided.dragHandleProps}
                              >
                                 {index + 1 + "."}&emsp;{item}
                              </div>
                           )}
                        </Draggable>
                     ))}
                     {provided.placeholder}
                  </div>
               )}
            </Droppable>
         </DragDropContext>
      </div>
   );
};

export default memo(PutInOrderField);
